export const ACTION_SALARY_LIST = 'ACTION_SALARY_LIST';

export const actSalaryList = (salaries) => {
    return {
        type: ACTION_SALARY_LIST,
        salaries
    }
}